import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { rydeColors } from "@ryde/theme";

export const CourseScheduleCellWrapperStyled = styled.div.attrs<IStyledAttributes>(
  {
    className: "cell_simple",
    [DATA_E2E_KEY]: "course-schedule-cell-template",
  },
)`
  & .course-schedule-cell__list {
    display: flex;
    flex-direction: column;
    margin: 0;
    padding: 0;
    list-style: none;
  }

  & .course-schedule-cell__row {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 5px;
    color: ${rydeColors.black};
  }

  & .course-schedule-cell__direction {
    font-weight: 500;
  }

  & .course-schedule-cell__day-types {
    width: 50px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
